/**
 * Anonymous device ID — UUID v4, генерируется при первом open приложения,
 * хранится в localStorage. НЕ identifier пользователя — просто способ
 * группировать события одного устройства в аналитике.
 *
 * Privacy:
 *   - НЕ содержит PII
 *   - При очистке localStorage (или resetAll через DebugBadge) пересоздаётся
 *     новый UUID — события «до» и «после» reset'а не связываются (это by design)
 *   - GDPR ok: pseudonym, не отслеживает identity, retention 90d на сервере
 *
 * Используется в `flush.ts` для batching POST'ов на backend `/events`.
 */

const KEY = 'sai-anon-id-v1';
/** Fallback ID когда localStorage недоступен (sandboxed iframe, private mode). */
const FALLBACK_ID = 'no-storage';

let cached: string | null = null;

export function getAnonId(): string {
  if (cached !== null) return cached;
  if (typeof window === 'undefined') {
    // SSR / тесты без window — детерминированный stub.
    return 'ssr';
  }
  try {
    const existing = window.localStorage.getItem(KEY);
    if (typeof existing === 'string' && existing.length >= 8 && existing.length <= 64) {
      cached = existing;
      return existing;
    }
    // crypto.randomUUID доступен везде где работает игра (HTTPS contexts +
    // Cloudflare Pages всегда HTTPS + jsdom его mock'ает).
    const fresh = crypto.randomUUID();
    window.localStorage.setItem(KEY, fresh);
    cached = fresh;
    return fresh;
  } catch {
    // localStorage может бросить в Safari private mode или sandboxed iframe.
    // Не блокируем — используем in-memory stub до конца сессии.
    cached = FALLBACK_ID;
    return FALLBACK_ID;
  }
}
